app.service('productCompareBar', function(
	productsInComparison,
	cookie,
	front,
	loading,
	broker,
	pageConfig,
	html
) {
	let $compareBox, $compareList, $compareButton;
	let state = {
		isVisible: false
	};

	let groupId;

	function goToCompareView() {
		cookie.set('refComp', window.location.href, { path: '/' });

		const params = productsInComparison
			.getByGroupId(groupId)
			.map((product, index) => `p${index + 1}=${product.productId}`)
			.join('&');
		const url = `/porownanie.bhtml?${params}`;

		loading.redirect(url);
	}

	function handleRemoveItemClick(e) {
		const { productId } = e.target.dataset;
		productsInComparison.remove({ productId });
		updateView();

		broker.trigger('REMOVE_FROM_COMPARISON', [productId]);
	}

	function setEvents() {
		$compareBox.on('click', '.js-compare', goToCompareView);
		$compareBox.on('click', '.js-remove-item', handleRemoveItemClick);
	}

	function setElements() {
		$compareBox = $('.compare-box');
		$compareList = $compareBox.find('.compare-box-list');
		$compareButton = $compareBox.find('.compare');
	}

	function updateView() {
		const productGroup = productsInComparison.getByGroupId(groupId);

		if (productGroup.length > 0) {
			$compareBox.addClass('is-visible');
			html.add('compare-box-visible');
			state.isVisible = true;
		} else {
			$compareBox.removeClass('is-visible');
			html.remove('compare-box-visible');
			state.isVisible = false;
		}

		if (productGroup.length > 1) {
			$compareBox.removeClass('show-message');
			$compareButton.removeClass('is-disabled');
		} else {
			$compareBox.addClass('show-message');
			$compareButton.addClass('is-disabled');
		}

		const products = productGroup
			.map(
				product => `<div class="compare-box-item">
				<img src="${product.productPhoto}" />
				<div data-product-group="${product.groupId}" data-product-id="${
					product.productId
				}" class="remove-item js-remove-item"></div>
			</div>`
			)
			.join('');

		$compareList.empty().html(products);
	}

	function getWatchedProductsGroupInComparision() {
		const lastSelectedGroupId = productsInComparison.getLastSelectedGroupId();
		const $watchedProducts = $('#watched-products .js-compare-add[data-product-group="' + lastSelectedGroupId + '"]');
		let $watchedProductInComparision;
		let watchedProductGroupId = '';
		if($watchedProducts.length) {
			$watchedProductInComparision = $watchedProducts.filter(
				(index, watchedProduct) => productsInComparison.has(""+$(watchedProduct).data('product-id'))
			);
			watchedProductGroupId = $watchedProductInComparision.length ? $watchedProductInComparision.data('product-group') : '';
		}
		return watchedProductGroupId;
	}

	function getConfig() {
		const config = {
			leaf: pageConfig.getData('productsList'),
			product: pageConfig.getData('productCard'),
			'watched-products': {
				groupId: front.page() === 'watched-products' ? getWatchedProductsGroupInComparision() : ''
			}
		};

		return config[front.page()];
	}

	function setGroup(nextGroupId) {
		groupId = String(nextGroupId);
	}

	function init() {
		setElements();
		setEvents();

		const config = getConfig();

		if (config) {
			setGroup(config.groupId);
			updateView();
		}
	}
	
	function isVisible() {
		return state.isVisible;
	}

	return {
		init,
		setGroup,
		updateView,
		isVisible
	};
});
